import { FC, ReactNode } from 'react';

export enum ButtonVariants {
  ACCENT = 'accent',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TEXT = 'text',
  DESTRUCTIVE = 'destructive',
}

export type ButtonSizeType = 'small' | 'medium' | 'big';

export type ButtonVisualProps = {
  children: ReactNode;
  variant: ButtonVariants;
  size?: ButtonSizeType;
  isFullWidth?: boolean;
  isLoading?: boolean;
  StartIcon?: FC;
  EndIcon?: FC;
  className?: string;
  disabled?: boolean;
};
